/** @jsx jsx */
import { jsx } from "theme-ui"
import Moment from "react-moment"

export default ({ dateCreated }) => {
  return <Moment format="Do MMMM YYYY" date={dateCreated} />
}
